import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountExposureQueryKey } from "../account.keys";

export type AdminAccountExposureBreakdown = Dtos.SuretyAccount.Exposure.Get.Response["exposure"];

export const useAdminFetchAccountExposure = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountExposureQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.SuretyAccount.Exposure.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/exposure`,
			),
		retry: false,
	});

	return {
		exposure: data?.exposure,
		exposureError: error,
		exposureIsLoading: isLoading,
		refetchExposure: refetch,
	};
};
